// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__IMhMY","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3KwBN","gfeWrapper":"CalendarEvent_gfeWrapper__31luv"};